import { useCallback, useEffect } from 'react'
import { isMobile } from 'utils/userAgent'
import { useReactGA4 } from 'GA4/useReactGA4'
import { useYoloModal } from 'lib/yoloModals/useYoloModal'
import { useUser } from './user/useUser'

const SIGN_IN_OBJECT = {
  // this component will receive `closeModal` prop to close programmatically the modal
  show: true,
  id: 'signIn',
  backdropBlurred: isMobile,
}

export const useWalletConnection = () => {
  const { gaEvent } = useReactGA4()
  const { updateModal, clearModal } = useYoloModal()
  const { isConnected, connector } = useUser('wallet')

  const disconnectWallet = useCallback(() => {
    connector?.handleClose && connector.handleClose()
    connector?.handleDisconnect && connector.handleDisconnect()
    // setReconnect(false)
    gaEvent('wallet_disconnect', { pathId: 'wallet.disconnect' })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connector])

  const connectWallet = useCallback(
    (type, referralCode) => {
      const modalObj = {
        ...SIGN_IN_OBJECT,
        id: type ? type : SIGN_IN_OBJECT.id,
        props: { type, referralCode },
      }
      updateModal(modalObj)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const closeWalletModal = useCallback(
    () => {
      clearModal('signIn')
      clearModal('signUp')
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  useEffect(() => {
    if (isConnected) closeWalletModal()
  }, [isConnected, closeWalletModal])

  return { connectWallet, disconnectWallet, closeWalletModal }
}
